import dayOptionsComponentUrl from './dayOptionsComponent.html';
class DayOptionsCtrl {
  constructor(EventCollection, ShiftUtils) {
    'ngInject';

    Object.assign(this, { EventCollection, ShiftUtils });
  }
}

export default {
  bindings: {
    dateString: '<date',
    readonly: '<?',
  },
  controllerAs: 'ctrl',
  controller: DayOptionsCtrl,
  templateUrl: dayOptionsComponentUrl,
};
